// Tiny React hook to track whether the tab is currently active/visible.
// Uses Page Visibility API plus window focus/blur as a backup.
import { useEffect, useState } from 'react';

export default function useAppVisibility() {
  const getActive = () => {
    try {
      const hasDoc = typeof document !== 'undefined';
      const hasWin = typeof window !== 'undefined';
      const visible = hasDoc ? document.visibilityState === 'visible' && !document.hidden : true;
      const focused = hasWin && typeof window.document.hasFocus === 'function' ? window.document.hasFocus() : true;
      return Boolean(visible && focused);
    } catch {
      return true;
    }
  };

  const [isActive, setIsActive] = useState(getActive);

  useEffect(() => {
    const update = () => setIsActive(getActive());
    try {
      document.addEventListener('visibilitychange', update);
      window.addEventListener('focus', update);
      window.addEventListener('blur', update);
    } catch {}
    return () => {
      try {
        document.removeEventListener('visibilitychange', update);
        window.removeEventListener('focus', update);
        window.removeEventListener('blur', update);
      } catch {}
    };
  }, []);

  return isActive;
}
